import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('SPAREPARTS SERVICE');

@Injectable({
  providedIn: 'root'
})
export class SparePartsService extends ApiBaseService<any>{

  constructor() {
    // Le pasamos 'spareparts' como el nombre del recurso a la clase base
    super('spareparts');
    log.debug('Servicio de Refacciones inicializado');
  }

}
